import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    backgroundColor: '#ffffff',
  },
  title: {
    fontSize: 24,
  },
  qrContainer: {
    padding: 16,
    backgroundColor: '#ffffff',
    borderRadius: 10,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  qrCode: {
    width: 200,
    height: 200,
  },
  instructionsContainer: {
    marginTop: 24,
    width: '100%',
    maxWidth: 400,
  },
  instructionsTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 12,
    color: '#333333',
  },
  instructionText: {
    fontSize: 16,
    marginBottom: 8,
    color: '#666666',
  },
  errorText: {
    color: '#ff0000',
    fontSize: 16,
    textAlign: 'center',
  },
  input: {
    width: '20%',
    height: 40,
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    padding: 10,
    margin: 10,
  },
  button: {
    backgroundColor: '#007AFF',
    padding: 10,
    borderRadius: 5,
    width: '20%',
    alignItems: 'center',
  },
  buttonText: {
    color: 'white',
    fontSize: 16,
  },
  completeButton: {
    marginTop: 20,
    backgroundColor: '#28a745',
    width: '30%',
  },
  mobileContainer: {
    padding: 20,
    width: '100%',
  },
  mobileTitle: {
    fontSize: 24,
    marginBottom: 10,
  },
  mobileInput: {
    height: 50,
    fontSize: 18,
    width: '90%',
    paddingHorizontal: 15,
  },
  mobileButton: {
    backgroundColor: '#2196F3',
    borderRadius: 8,
    width: '90%',
    height: 50,
    alignItems: 'center',
    justifyContent: 'center',
  },
  mobileButtonText: {
    fontSize: 18,
  },
  mobileQrContainer: {
    width: '100%',
    height: 200,
    marginVertical: 20,
  },
  mobileQrCode: {
    width: '100%',
    height: '100%',
  },
  mobileInstructionsContainer: {
    width: '100%',
    padding: 15,
  },
  mobileInstructionsTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 15,
  },
  mobileInstructionText: {
    fontSize: 16,
    marginBottom: 10,
    lineHeight: 24,
  },
});

export default styles;